import React, { Children, useState } from 'react'

import IconButton from '@mui/material/IconButton'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

import NextIcon from 'icons/NextIcon'
import PrevIcon from 'icons/PrevIcon'

export default function Carousel({ children }) {
  const { palette, spacing, breakpoints } = useTheme()
  const isMobile = useMediaQuery(breakpoints.down('sm'))
  const [index, setIndex] = useState(0)

  return (
    <div style={{ position: 'relative', overflow: 'hidden' }}>
      <div
        style={{
          padding: isMobile ? `0 ${spacing(6)}` : '0 70px',
          display: 'flex',
          gap: spacing(3),
          transform: `translateX(${index * -200}px)`,
          transitionDuration: '0.3s',
          transitionTimingFunction: 'ease-in-out',
        }}
      >
        {children}
      </div>
      {index > 0 && (
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: spacing(3),
            transform: 'translateY(-50%)',
            zIndex: 100,
          }}
        >
          <IconButton
            style={{
              padding: 0,
              backgroundColor: 'rgba(255, 255, 255, 0.8)',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.9)'
              }
            }}
            onClick={() => setIndex(index - 1)}
          >
            <PrevIcon color={palette.primary.main} />
          </IconButton>
        </div>
      )}
      {index + 1 < Children.count(children) && (
        <div
          style={{
            position: 'absolute',
            top: '50%',
            right: spacing(3),
            transform: 'translateY(-50%)',
            zIndex: 100,
          }}
        >
          <IconButton
            style={{
              padding: 0,
              backgroundColor: 'rgba(255, 255, 255, 0.8)',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.9)'
              }
            }}
            onClick={() => setIndex(index + 1)}
          >
            <NextIcon color={palette.primary.main} />
          </IconButton>
        </div>
      )}
    </div>
  )
}
